import { useMemo, useState } from "react";
import Menu from "./Menu";
import JobAndPay from "./JobAndpay";
import Personal from "./Personal";
import Qualifications from "./Qualifications";
import Availability from "./Availability";
import Settings from "./Settings";
import TimeOff from "./TimeOff";
import History from "./History";
import ExpectedHours from "./ExpectedHours";
import WorkingShifts from "./WorkingShifts";
import PBJ from "./PBJ";
import Notes from "./Notes";
import Documents from "./Documents";
import Schedule from "./Schedule";
import Notifications from "./Notifications";

function Content({ user }: any) {
    const [selected, setSelected] = useState("job-and-pay");
    const content = useMemo(() => {
        switch (selected) {
            default:
            case "profile-job-pay": {
                return <JobAndPay user={user} />
            }
            case "personal": {
                return <Personal user={user} />
            }
            case "qualifications": {
                return <Qualifications user={user} />
            }
            case "availability": {
                return <Availability user={user} />
            }
            case "settings": {
                return <Settings user={user} />
            }
            case "time-off": {
                return <TimeOff user={user} />
            }
            case "history": {
                return <History user={user} />
            }
            case "expected-hours": {
                return <ExpectedHours user={user} />
            }
            case "working-shifts": {
                return <WorkingShifts user={user} />
            }
            case "pbj": {
                return <PBJ user={user} />
            }
            case "notes": {
                return <Notes user={user} />
            }
            case "documents": {
                return <Documents user={user} />
            }
            case "schedule": {
                return <Schedule user={user} />
            }
            case "notifications": {
                return <Notifications user={user} />
            }
        }
    }, [selected, user]);

    return (
        <div className="tw-flex tw-flex-col tw-flex-1 tw-min-h-0">
            <Menu selected={selected} setSelected={setSelected} />
            <div className="tw-flex-1 tw-overflow-y-auto tw-min-h-0 tw-py-3 tw-w-full">
                {content}
            </div>
        </div>
    );
}

export default Content;
